<ion-list>
  <ion-item *ngFor="let app of apps" button lines="none">
    <!-- <ion-avatar slot="start"> -->
    <ion-img slot="start" class="logo" [src]="app.logoUrl"></ion-img>
    <!-- </ion-avatar> -->

    <ion-label>{{ app.name }}</ion-label>

    <ion-buttons slot="end">
      <ion-button
        [href]="app.playStoreLink"
        target="_blank"
        rel="noopener noreferrer"
        c3Tooltip="Vai al Play Store"
      >
        <ion-icon slot="icon-only" [src]="'google-play' | getIcon"></ion-icon>
      </ion-button>

      <ion-button
        [href]="app.webappUrl"
        target="_blank"
        rel="noopener noreferrer"
        c3Tooltip="Web App"
      >
        <ion-icon slot="icon-only" [src]="'web' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-item>
</ion-list>
